import { render, staticRenderFns } from "./data69.vue?vue&type=template&id=f72227de&scoped=true"
import script from "./data69.vue?vue&type=script&lang=js"
export * from "./data69.vue?vue&type=script&lang=js"
import style1 from "./data69.vue?vue&type=style&index=1&id=f72227de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72227de",
  null
  
)

export default component.exports